/* Nordic Weaving: flyt handlingsrækken ned under produktnavnet. 8/9-2026.

   PROBLEMET: cart-item.liquid lægger Fjern i kolonnen .cart-item__quantity,
   som på kurvsiden er smal. Da vi satte Gem til senere ind ved siden af,
   brækkede teksten over to linjer og Fjern hoppede ned under. Det så klemt ud.

   LØSNINGEN: begge handlinger flyttes ned i .cart-item__description, som er
   den brede kolonne, præcis som i mockuppen. Vi flytter temaets EGET
   Fjern-link med, så klikket stadig er temaets eget og gentegningen
   fortsætter med at virke.

   Kører efter nw-gem.js, som har sat knappen ind. Begge hænger på en
   MutationObserver, fordi temaet gentegner hele varelisten ved hver ændring.
*/
(function (w, d) {
  'use strict';

  function flyt() {
    d.querySelectorAll('.cart-item').forEach(function (linje) {
      if (linje.querySelector('.nw-akt')) return;

      var gem   = linje.querySelector('.nw-gem-btn');
      var fjern = linje.querySelector('.cart-item__remove');
      var desc  = linje.querySelector('.cart-item__description');
      if (!gem || !fjern || !desc) return;

      var raekke = d.createElement('div');
      raekke.className = 'nw-akt';
      raekke.appendChild(gem);
      raekke.appendChild(fjern);
      desc.appendChild(raekke);
    });
  }

  var planlagt = null;
  function planlaeg() {
    if (planlagt) return;
    planlagt = setTimeout(function () { planlagt = null; flyt(); }, 90);
  }

  function start() {
    flyt();
    try {
      new MutationObserver(planlaeg).observe(d.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', start) : start();
})(window, document);